import update from "immutability-helper";
import { SET_FIELD_VALUE, CLEAR_STORE } from "../../constants/actionTypes";

const initialState = {
  searchValue: "",
  selectedProfile: null,
  potentialMatches: {},
};

const correctConfirmValue = (state = initialState, action) => {
  switch (action.type) {
    case SET_FIELD_VALUE:
      return update(state, {
        [action.field]: { $set: action.value },
      });
    case CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

export default correctConfirmValue;
